import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchMe = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setOrganization(data.organization);
    } catch (e) {
      setUser(null);
      setOrganization(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("flowsend_token");
    if (!token) {
      setLoading(false);
      return;
    }
    fetchMe();
  }, [fetchMe]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("flowsend_token", data.access_token);
    await fetchMe();
    return data;
  };

  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    localStorage.setItem("flowsend_token", data.access_token);
    await fetchMe();
    return data;
  };

  const googleLogin = async (token) => {
    const { data } = await api.post("/auth/google", { token });
    localStorage.setItem("flowsend_token", data.access_token);
    await fetchMe();
    return data;
  };

  const logout = () => {
    localStorage.removeItem("flowsend_token");
    setUser(null);
    setOrganization(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{ user, organization, loading, login, signup, googleLogin, logout, refresh: fetchMe }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
